/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TransferBatchesControllerUpdateBatchMutationRequest, TransferBatchesControllerUpdateBatchMutationResponse, TransferBatchesControllerUpdateBatchPathParams, TransferBatchesControllerUpdateBatch400, TransferBatchesControllerUpdateBatch401, TransferBatchesControllerUpdateBatch403, TransferBatchesControllerUpdateBatch404 } from "../../models/transferBatchesController/TransferBatchesControllerUpdateBatch";

function getTransferBatchesControllerUpdateBatchUrl(id: TransferBatchesControllerUpdateBatchPathParams["id"]) {
  const res = { method: 'PUT', url: `/api/v1/transfer-batches/${id}` as const }  
  return res
}

/**
 * @summary Update a transfer batch
 * {@link /api/v1/transfer-batches/:id}
 */
export async function transferBatchesControllerUpdateBatch(id: TransferBatchesControllerUpdateBatchPathParams["id"], data?: TransferBatchesControllerUpdateBatchMutationRequest, config: Partial<RequestConfig<TransferBatchesControllerUpdateBatchMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TransferBatchesControllerUpdateBatchMutationResponse, ResponseErrorConfig<TransferBatchesControllerUpdateBatch400 | TransferBatchesControllerUpdateBatch401 | TransferBatchesControllerUpdateBatch403 | TransferBatchesControllerUpdateBatch404>, TransferBatchesControllerUpdateBatchMutationRequest>({ method : "PUT", url : getTransferBatchesControllerUpdateBatchUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}